import { render, staticRenderFns } from "./VideoTest.vue?vue&type=template&id=1e0f470f&scoped=true&"
import script from "./VideoTest.vue?vue&type=script&lang=js&"
export * from "./VideoTest.vue?vue&type=script&lang=js&"
import style0 from "./VideoTest.vue?vue&type=style&index=0&id=1e0f470f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0f470f",
  null
  
)

export default component.exports